import type { ReactNode } from 'react';
import { SkeletonLines } from '../../../components/Skeleton';
import styles from './ShellSkeleton.module.css';

/**
 * What the app shows while the router's `beforeLoad` gate is deciding whether this
 * visitor may be here at all.
 *
 * This is the one case CLAUDE.md §5a permits a skeleton: the first paint of data
 * that has never been on screen and is not in cache. It is shaped like the shell
 * that is about to arrive — a header bar, a module strip, content — because a
 * skeleton whose shape does not match makes the real thing jump into place.
 *
 * On every later navigation the session is already cached, so the gate resolves
 * synchronously and this never renders at all.
 */
export function ShellSkeleton(): ReactNode {
  return (
    <div className={styles.skeleton} aria-busy="true" aria-label="Loading">
      <div className={styles.bar} />
      <div className={styles.strip} />
      <div className={styles.content}>
        <SkeletonLines count={6} />
      </div>
    </div>
  );
}
